// extracted by mini-css-extract-plugin
export default {"title":"other_personal_projects_title__ZG2c4","grid-view":"other_personal_projects_grid-view__JRi0h"};